import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from '../MyAppCommonConfig';
import { DResult } from '../models/common.models/dresult.model';
import { StaticPageGetByPageKeyOutputDTO } from '../models/contents.models/staticPage.models/staticPageGetByPageKeyOutputDTO.model';

@Injectable()
export class StaticPagesSiteService {

    constructor(private http: HttpClient) {

    }

    GetByPageKey(pageKey: string) {       
        var urlAddress: string = `${API_ServerAddress}/api/v1/StaticPages/GetByPageKey/${pageKey}`;       
        return this.http.get<DResult<StaticPageGetByPageKeyOutputDTO>>(urlAddress);
    }
   
}
